import { changeWorkSpace, getWorkSpaces } from '../routines/workspaceRoutines';
import { logOut } from '../routines';
import { DEFAULT_ERROR_MESSAGE } from '../../common/constants/CommonConstants';

const initialState = {
  isLoading: false,
  errorMessage: '',
  isError: false,
  currentWorkSpace: {},
  workSpaces: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case changeWorkSpace.SUCCESS: {
      return {
        ...state,
        currentWorkSpace: action.payload,
        isLoading: false,
      };
    }
    case getWorkSpaces.SUCCESS:
      return { ...state, workSpaces: action.payload.tenants, isLoading: false };

    case changeWorkSpace.TRIGGER:
    case getWorkSpaces.TRIGGER: {
      return {
        ...state,
        isLoading: true,
      };
    }
    // Logout should reset all the reducers
    case logOut.SUCCESS:
      return {
        ...initialState,
      };
    case getWorkSpaces.FAILURE:
    case changeWorkSpace.FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoginError: true,
        errorMessage:
          action.payload?.error.message ||
          action.payload?.error.response?.data?.message ||
          DEFAULT_ERROR_MESSAGE,
        isError: true,
        isResendMFALoading: false,
      };
    default:
      return state;
  }
};
